import prompthubEllipse from '../../../images/icons/prompthub-ellipse.svg';
import { Author } from '../../../components/types';
import { getImageDataFallback } from '../../../utils/images';

import { PromptResponse } from './types';

const DEFAULT_AUTHOR: Author = {
    name: 'Редакция',
    image: prompthubEllipse,
};

const getAuthorOrDefault = (author: Author): Author => {
    if (author.isEditor) {
        return { ...DEFAULT_AUTHOR, promptsCount: author.promptsCount };
    }

    return author;
};

const getImageDataOrFallback = (response: PromptResponse) => {
    if (response.imageData.urlOptimized) {
        return response.imageData;
    }

    return getImageDataFallback(response.id);
};

export const transformPromptDtoToModel = (response: PromptResponse) => ({
    ...response,
    imageData: getImageDataOrFallback(response),
    author: getAuthorOrDefault(response.author),
    createdAt: response.createdAt || '2025-10-30T12:00:00Z',
});
